import { IChatRepository, ChatRequestEntity, ResponseValueObject } from '@gishub/domain';
import { axiosClient } from '../http/axios-client';

export class ChatRepository implements IChatRepository {
  private readonly endpoint = '/ai/chat/stream';

  async sendMessageStream(request: ChatRequestEntity, signal?: AbortSignal): Promise<ResponseValueObject<Response>> {
    try {
      const response = await fetch(axiosClient.defaults.baseURL + this.endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(request),
        signal,
      });

      if (!response.ok) {
        return new ResponseValueObject<Response>(false, undefined, 'Error al iniciar streaming', [`HTTP ${response.status}`]);
      }

      return new ResponseValueObject<Response>(true, response);
    } catch (error: any) {
      console.error('Error sending chat message:', error);
      return new ResponseValueObject<Response>(
        false,
        undefined,
        error.message || 'Error de conexión al enviar mensaje',
        error.errors || [error.message || 'Error desconocido']
      );
    }
  }
}
